export default {
  title: 'Card Quote'
}

const Template = args => `
  <cradlepoint-container max-width="600px">
    <cradlepoint-card-quote type="${args['type']}" class="bg-charcoal">
      ${args['content'] && args['content']}
    </cradlepoint-card-quote>
  </cradlepoint-container>
`;

export const TypeA = Template.bind({});
export const TypeB = Template.bind({});

TypeA.args = {
  type: 'a',
  content: `
    <p class="quote text-white">We are ready and waiting for 5G. We need next-gen mobile networking to run our next-gen applications.</p>
    <p class="attribution text-white"><span style="font-family:Eina01-Bold;">Bilfinger Global IT</span>, regional IT business partner</p>
  `
}

TypeB.args = {
  type: 'b',
  content: `
    <p class="quote text-white">
      Our use of cellular broadband and Private LTE for on-site Point-of-Sale and
      guest service support has paved the way for new and innovative ways to interact
      with our guests and clients. Cradlepoint&apos;s solutions expanded the reach of our
      branch networks, resulting in even more engagement and unique experiences.
    </p>
    <p class="attribution text-white">
      <span style="font-family:Eina01-Bold;">Guest experience manager for Disney</span>
    </p>
  `
}
